import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\RYAN-NB\\Documents\\MACNESIA\\macspace.id\\src\\app\\news\\clientComponent.tsx");
